import React from "react";
import searchIcon from "../../../assets/images/tarrifManagement/search.svg";

const CustomSearchFilter = ({
  searchData,
  setSearchData,
  setFilterData,
  setFilterType,
  placeholder = "Search",
}) => {
  const [isFocused, setIsFocused] = React.useState(false);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        backgroundColor: "white",
        border: `2px solid ${
          isFocused || searchData
            ? "rgba(57, 181, 74, 1)"
            : "rgba(217, 217, 217, 1)"
        }`,
        borderRadius: "10px",
        padding: "0 12px",
        height: "39px",
        gap: "8px",
        boxSizing: "border-box",
        transition: "border-color 0.2s ease-in-out",
        boxShadow: isFocused ? "0 0 0 1px rgba(57, 181, 74, 0.1)" : "none",
      }}
    >
      <img
        src={searchIcon}
        alt="search"
        style={{ width: "20px", height: "20px", flexShrink: 0 }}
      />
      <input
        type="text"
        placeholder={placeholder}
        value={searchData}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        onChange={(e) => {
          setSearchData(e.target.value.trimStart());
          if (setFilterType) setFilterType("search");
          if (setFilterData) setFilterData([]);
        }}
        style={{
          border: "none",
          outline: "none",
          width: "100%",
          fontSize: "14px",
          backgroundColor: "transparent",
          color: "#313131",
        }}
      />
    </div>
  );
};

export default CustomSearchFilter;
